module.exports = __webpack_public_path__ + "static/media/ic_freehand_selected.3758c022.svg";